module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f8cdb37eb003162f43ef176f3206be7d.png";